import { useEffect } from 'react';
import { InvoicesStatuses } from 'store/invoices/types';
import { EmailNotificationOverallStatuses } from 'types/common';
import useInvoices from './useInvoices';

const REFRESH_DELAY_TIME = 5000;

const useInvoiceAutoRefresh = (
    invoiceId?: string,
    status?: InvoicesStatuses,
    overallStatus?: EmailNotificationOverallStatuses,
    sendInProgress?: boolean
) => {
    const { getInvoiceById } = useInvoices();

    useEffect(() => {
        const shouldRefresh =
            (status === InvoicesStatuses.DRAFT_NON_EDITABLE &&
                overallStatus !== EmailNotificationOverallStatuses.FAILED) ||
            sendInProgress;
        if (!invoiceId || !shouldRefresh) return;

        const interval = setInterval(() => {
            getInvoiceById(invoiceId);
        }, REFRESH_DELAY_TIME);

        return () => clearInterval(interval);
    }, [invoiceId, status, overallStatus, sendInProgress, getInvoiceById]);
};

export default useInvoiceAutoRefresh;
